export const config = {
  readonly: false, 
  placeholder: "লিখুন...",
  uploader: {
    insertImageAsBase64URI: true,
  },
  height: 250,
  removeButtons: [
    "fullsize",
    "about",
    "outdent",
    "indent",
    "video",
    "print",
    "superscript",
    "subscript",
    "file",
    "cut",
    "selectall",
  ],
};
